module.exports = __webpack_public_path__ + "static/img/bb.0581e537.png";